export const plans1 = [
	{
		title: 'PLAN STANDARD',
		descrition: 'El flujo de producción completo.',
		price: '$899 USD',
		priceBefore: '$1.112 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_BN8JOQ36AM',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTI5OSZpZD1MaWJlbCBIVUIgUGxhbiBDb3JlIC0gQWNjZXNvIDEgYfFv',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Acceso total a los entrenamientos.',
			},
			{
				title: 'Acceso a todos los entrenamientos.',
			},
			{
				title: 'Feedback online en vivo por 6 meses.',
			},
			{
				title: 'Acceso por un año al contenido.',
			},
			{
				title: 'Acceso a Discord privado.',
			},
		],
		center: true,
		top: false,
		ball: true,
		promo: '30% DTO',
		type: 'presencial',
	},
	{
		title: 'PLAN GROW',
		descrition: 'El flujo de producción completo.',
		price: '$1.229  USD',
		priceBefore: '$1.481 USD',
		urls: {
			ninguno: 'https://checkout.bold.co/payment/LNK_L7VL5F3M3C',
			internacional:
				'https://libel.academy/pago-paypal/payment.html?YW1vdW50PTM5OSZpZD1MaWJlbCBIVUIgUGxhbiBGb3JnZSAtIEFjY2VzbyAxIGHxbw==',
		},
		temario: 'https://drive.google.com/file/d/1_ydjtZ3CJ-6nBCndavf-agaUwd7BU-n-/view?usp=sharing',
		items: [
			{
				title: 'Acceso total a los entrenamientos.',
			},
			{
				title: 'Feedback online en vivo por 6 meses.',
			},
			{
				title: 'Acceso 1 año + 4 meses.',
			},
			{
				title: 'Acceso a Discord privado.',
			},
			{
				title: 'Licencia CC5 de por vida.',
			},
		],
		center: true,
		top: true,
		ball: false,
		promo: '30% DTO',
		type: 'presencial',
	},
];
